import fromUnixTime from 'date-fns/fromUnixTime';

export const getDateFromUnixTime = (timestamp: number): Date => fromUnixTime(timestamp);

export default getDateFromUnixTime;
